import { getMixer } from './basler-components.es787.js';
import { mixNumber } from './basler-components.es769.js';

function mix(from, to, p) {
    if (typeof from === "number" &&
        typeof to === "number" &&
        typeof p === "number") {
        return mixNumber(from, to, p);
    }
    const mixer = getMixer(from);
    return mixer(from, to);
}

export { mix };
